import React from 'react';
import PropTypes from 'prop-types';
import { Fade } from "react-reveal";
import Lottie from "lottie-react";
import ErrorAnim from './errorAnim.json';
import Text from '../../text/text';
import { useMediaQuery } from '@react-hook/media-query';

function ErrorView({ text }) {
  const isMobileDevice = useMediaQuery('(min-width: 1px) and (max-width: 991px)');

  const styleLottieAnim = {
    height: isMobileDevice ? 280 : 330,
  };

  return (
    <Fade duration={600} opposite>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <Text type="title">
          Something went wrong
        </Text>
        <Lottie animationData={ErrorAnim} loop={true} autoPlay={true} style={styleLottieAnim} />
        <div className="mb-3">
          <Text type="text">
            {text || "Please try again"}
          </Text>
        </div>
      </div>
    </Fade>
  )
}

ErrorView.propTypes = {
  text: PropTypes.string
};

export default ErrorView;
